import { useEffect, useRef } from "react";

export const useAutoOpen = (shouldOpen: boolean, callback: () => void, delay = 0) => {
  const hasAutoOpened = useRef(false);

  useEffect(() => {
    if (!shouldOpen) return;

    const timer = setTimeout(() => {
      if (!hasAutoOpened.current) {
        hasAutoOpened.current = true;
        callback();
      }
    }, delay);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
